/* @jsx m */
import m from 'mithril';

export default function deviceWrapper() {
  return {
    view: (vnode) => {
      return (
        <div class="row">
          <div class="outerPhone col s12 m6 push-m3 l4 push-l4">
            <div class="innerPhone chat">
              {vnode.children}
            </div>
            <div class="row">
              <div className="center-align device-brand">
                MOBILE
              </div>
            </div>
          </div>
        </div>
      );
    },
  }
}
